export const copyQuestionTypes = {
  QUESTION_ONLY: 'QUESTION_ONLY',
  EVERYTHING: 'EVERYTHING',
}
